import React, { FC, HTMLAttributes } from 'react';
import css from './Modal.module.scss';
import classNames from 'classnames';

const cx = classNames.bind(css);

interface ModalProps extends HTMLAttributes<HTMLDivElement>{
  visible: boolean;
  setVisible: any;
}

const Modal: FC<ModalProps> = ({ children, visible, setVisible, className }) => {
 return (
  <div className={cx(css.wrapper, visible ? css.active : '')} onClick={() => setVisible(false)}>
      <div className={cx(css.content, className)} onClick={(e) => e.stopPropagation()}>
          { children }
      </div>
  </div>
 );
};

export default Modal;